import React, { useEffect } from 'react';
import { Routes as RouterRoutes, Route, Navigate, useLocation } from 'react-router-dom';
import DashboardPageConnected from './components/pages/Dashboard/DashboardPageConnected';
import Calendar from './components/pages/Calendar';
import LoginPageConnected from './components/pages/Login/LoginPageConnected';
import GetStartedPageConnected from './components/pages/GetStarted/GetStartedPageConnected';
import ShipmentsPageConnected from './components/pages/shipments/grid/ShipmentsPageConnected';
import ShipmentsBoardPageConnected from './components/pages/shipments/board/ShipmentsBoardPageConnected';
import ConsolidationsPageConnected from './components/pages/shipments/consolidations/ConsolidationsPageConnected';
import ConsolidationDetailsPageConnected from './components/pages/shipments/consolidations/ConsolidationDetailsPageConnected';
import SingleShipmentPageConnected from './components/pages/singleShipment/SingleShipmentPageConnected';
import SingleShipmentFormConnected from './components/pages/singleShipment/ShipmentForm/ShipmentFormConnected';
import { PagesRoutes } from './routing/PagesRoutes';
import AuthRoute from './routing/AuthRoute';
import 'antd/dist/antd.css';
import NotificationsPageConnected from './components/pages/Notifications/NotificationsPageConnected';
import EditProfilePageConnected from './components/pages/User/EditProfilePageConnected';
import BusinessPartnersPageConnected from './components/pages/businessPartners/BusinessPartnersPageConnected';
import SingleBusinessPartnerPageConnected from './components/pages/businessPartners/singleBusinessPartner/SingleBusinessPartnerPageConnected';
import PurchaseOrdersPageConnected from './components/pages/purchaseOrders/PurchaseOrdersPageConnected';
import SinglePurchaseOrderPageConnected from './components/pages/singlePurchaseOrder/SinglePurchaseOrderPageConnected';
import SinglePurchaseOrderFormConnected from './components/pages/singlePurchaseOrder/PurchaseOrderForm/PurchaseOrderFormConnected';
import ExceptionPage from './components/pages/ExceptionPage/ExceptionPage';
import { connect } from 'react-redux';
import { RootState } from './state/store/store';
import { localizationSelectors } from './state/ducks/localization/selectors';
import BidFormConnected from './components/pages/singleBid/BidForm/BidFormConnected';
import QuotationReplyPageConnected from './components/pages/public/QuotationReply/QuotationReplyPageConnected';
import OrderConfirmationPageConnected from './components/pages/public/OrderConfirmation/OrderConfirmationPageConnected';
import PoSupplierUpdatesConnected from './components/pages/public/PoSupplierUpdates/PoSupplierUpdatesConnected';
import BidsPageConnected from './components/pages/bids/BidsPageConnected';
import SingleBidPageConnected from './components/pages/bids/singleBid/SingleBidPageConnected';
import ChatsPageConnected from './components/pages/Chat/ChatsPageConnected';
import { userSelectors } from './state/ducks/user/selectors';
import { featureFlagsModel } from './models/entities/businessPartner/settings';
import ContactsPageConnected from './components/pages/Chat/ContactsPageConnected';
import ContainersPageConnected from './components/pages/Containers/ContainersPageConnected';
import UsersMgmtPageConnected from './components/pages/Admin/Users/UsersMgmtPageConnected';
import EditUserPageConnected from './components/pages/Admin/Users/AddEditUser/AddEditUserPaneConnected';
import CompaniesMgmtPageConnected from './components/pages/Admin/Companies/CompaniesMgmtPageConnected';
import PublicRoute from './routing/PublicRoute';
import ProductsPageConnected from './components/pages/products/ProductsPageConnected';
import PurchaseDemandsPageConnected from './components/pages/purchaseDemands/PurchaseDemandsPageConnected';
import SinglePurchaseDemandPageConnected from './components/pages/singlePurchaseDemand/SinglePurchaseDemandPageConnected';
import SingleCompanyPageConnected from './components/pages/Admin/Companies/SingleCompanyPage/SingleCompanyPageConnected';
import CompaniesRelationsPageConnected from './components/pages/Admin/CompaniesRelations/CompaniesRelationsPageConnected';
import DeletedRecordsPageConnected from './components/pages/Admin/DeletedRecords/DeletedRecordsPageConnected';
import UserSettingsPageConnected from './components/pages/User/UserSettings/UserSettingsPageConnected';
import InventoryLogsPageConnected from './components/pages/inventory/InventoryLogsPageConnected';
import OrdersPageConnected from './components/pages/Orders/OrdersPageConnected';
import OrdersBoardPageConnected from './components/pages/Orders/OrdersBoardPageConnected';
import OrderFormConnected from './components/pages/SingleOrder/OrderForm/OrderFormConnected';
import InternalFlowInventoryLogsPageConnected from './components/pages/InternalFlowInventoryLogs/InternalFlowInventoryLogsPageConnected';
import TarrifsPageConnected from './components/pages/Tariffs/TariffsPageConnected';
import TariffFormConnected from './components/pages/SingleTariff/TariffForm/TariffFormConnected';
import SingleTatiffPageConnected from './components/pages/SingleTariff/SingleTatiffPageConnected';
import SingleOrderPageConnected from './components/pages/SingleOrder/SingleOrderPageConnected';
import CarrierWeightPricing from './components/pages/CarrierWeightPricing/CarrierWeightPricingConnected';
import FollowUpConnected from './components/pages/Followup/FollowUpConnected';
import AccountingOversightPageConnected from './components/pages/AccountingOversight/AccountingOversightPageConnected';
import AuditDashboardPageConnected from './components/pages/Audit/AuditDashboardPageConnectedRefactored';
import ShippingEstimatesPageConnected from './components/pages/public/ShippingEstimates/ShippingEstimatesPageConnected';
import PlatformLayout from './components/pages/Platform/PlatformLayout';
import PlatformHubPageConnected from './components/pages/Platform/Hub/PlatformHubPageConnected';
import PlatformCompaniesPageConnected from './components/pages/Platform/Companies/PlatformCompaniesPageConnected';
import PlatformUsersPageConnected from './components/pages/Platform/Users/PlatformUsersPageConnected';
import PlatformAuditPageConnected from './components/pages/Platform/Audit/PlatformAuditPageConnected';
import PlatformSuperAdminsPageConnected from './components/pages/Platform/SuperAdmins/PlatformSuperAdminsPageConnected';

type Props = {
    setCurrentPageTitle: (title: string | null) => void;
    setHasGoBackBtn: (visible: boolean) => void;
    addPath: (path: string) => void;
    localization: any;
    featureFlags?: featureFlagsModel;
};

const Routes = ({ setCurrentPageTitle, setHasGoBackBtn, addPath, localization, featureFlags }: Props) => {
    const location = useLocation();

    useEffect(() => {
        addPath(location.pathname);
        setCurrentPageTitle(mapRouteToTitle(location.pathname));
    }, [location]);

    const mapRouteToTitle = (pathname: string) => {
        const localizationTitle = getLocalizationPathKey(pathname);

        return localizationTitle ? localization.titles[localizationTitle] : null;
    };

    const getLocalizationPathKey = (pathname: string) => {
        const localizationPathTitleKey = Object.keys(PagesRoutes)
            .find((key: string) => (PagesRoutes as any)[key] === pathname)
            ?.toLowerCase();
        let newLocalizationPathTitleKey = '';

        const pathSegments: string[] = pathname.substring(1).split('/');
        if (!localizationPathTitleKey) {
            pathSegments.forEach((segment: string, i: number) => {
                i === 0 ? (newLocalizationPathTitleKey += segment) : (newLocalizationPathTitleKey = 'sub_' + newLocalizationPathTitleKey);
            });
        }

        if (pathSegments.length >= 2) {
            setHasGoBackBtn(true);
        } else {
            setHasGoBackBtn(false);
        }

        return localizationPathTitleKey || newLocalizationPathTitleKey;
    };

    const NoFeatureComp = () => <ExceptionPage status={404} title="Doesn't have access to this feature" />;

    return (
        <>
            <RouterRoutes>
                <Route path={PagesRoutes.Home} element={<AuthRoute component={DashboardPageConnected} />} />
                <Route path={PagesRoutes.Calendar} element={<AuthRoute component={Calendar} />} />
                <Route path={PagesRoutes.Shipments} element={<AuthRoute component={ShipmentsPageConnected} />} />
                <Route path={PagesRoutes.ShipmentsBoard} element={<AuthRoute component={ShipmentsBoardPageConnected} />} />
                <Route path={PagesRoutes.ShipmentsConsolidations} element={<AuthRoute component={ConsolidationsPageConnected} />} />
                <Route path={`${PagesRoutes.ShipmentsConsolidations}/:master`} element={<AuthRoute component={ConsolidationDetailsPageConnected} />} />
                <Route path={`${PagesRoutes.Shipments}/:shipmentId`} element={<AuthRoute component={SingleShipmentPageConnected} />} />
                <Route 
                    path={`${PagesRoutes.EditShipment}/:shipmentId`} 
                    element={<AuthRoute component={!featureFlags?.UNDER_FORWARDER ? SingleShipmentFormConnected : NoFeatureComp} />} 
                />
                <Route path={`${PagesRoutes.DuplicateShipment}/:shipmentId`} element={<AuthRoute component={SingleShipmentFormConnected} />} />
                <Route path={PagesRoutes.NewShipment} element={<AuthRoute component={SingleShipmentFormConnected} />} />
                <Route path={PagesRoutes.Notifications} element={<AuthRoute component={NotificationsPageConnected} />} />
                <Route path={PagesRoutes.EditProfile} element={<AuthRoute component={EditProfilePageConnected} />} />
                <Route path={PagesRoutes.UserSettings} element={<AuthRoute component={UserSettingsPageConnected} />} />
                <Route 
                    path={PagesRoutes.BusinessPartners} 
                    element={<AuthRoute component={!featureFlags?.UNDER_FORWARDER ? BusinessPartnersPageConnected : NoFeatureComp} />} 
                />
                <Route path={`${PagesRoutes.BusinessPartners}/:companyId`} element={<AuthRoute component={SingleBusinessPartnerPageConnected} />} />
                <Route path={PagesRoutes.PurchaseOrders} element={<AuthRoute component={featureFlags?.PO ? PurchaseOrdersPageConnected : NoFeatureComp} />} />
                <Route 
                    path={`${PagesRoutes.PurchaseOrders}/:purchaseOrderId`} 
                    element={<AuthRoute component={featureFlags?.PO ? SinglePurchaseOrderPageConnected : NoFeatureComp} />} 
                />
                <Route 
                    path={`${PagesRoutes.EditPurchaseOrder}/:purchaseOrderId`} 
                    element={<AuthRoute component={featureFlags?.PO ? SinglePurchaseOrderFormConnected : NoFeatureComp} />} 
                />
                <Route 
                    path={`${PagesRoutes.DuplicatePurchaseOrder}/:purchaseOrderId`} 
                    element={<AuthRoute component={featureFlags?.PO ? SinglePurchaseOrderFormConnected : NoFeatureComp} />} 
                />
                <Route path={PagesRoutes.NewPurchaseOrder} element={<AuthRoute component={featureFlags?.PO ? SinglePurchaseOrderFormConnected : NoFeatureComp} />} />

                <Route path={PagesRoutes.PurchaseDemands} element={<AuthRoute component={featureFlags?.PD ? PurchaseDemandsPageConnected : NoFeatureComp} />} />
                <Route 
                    path={`${PagesRoutes.PurchaseDemands}/:purchaseDemandId`} 
                    element={<AuthRoute component={featureFlags?.PD ? SinglePurchaseDemandPageConnected : NoFeatureComp} />} 
                />
                <Route path={PagesRoutes.Bids} element={<AuthRoute component={featureFlags?.BIDS ? BidsPageConnected : NoFeatureComp} />} />
                <Route path={`${PagesRoutes.Bids}/:bidId`} element={<AuthRoute component={featureFlags?.BIDS ? SingleBidPageConnected : NoFeatureComp} />} />
                <Route path={`${PagesRoutes.EditBid}/:bidId`} element={<AuthRoute component={featureFlags?.BIDS ? BidFormConnected : NoFeatureComp} />} />
                <Route path={PagesRoutes.NewBid} element={<AuthRoute component={featureFlags?.BIDS ? BidFormConnected : NoFeatureComp} />} />
                {/* <Route path={PagesRoutes.Contacts} element={<AuthRoute component={featureFlags?.CHAT ? ContactsPageConnected : NoFeatureComp} />} /> */}
                <Route path={PagesRoutes.Messages} element={<AuthRoute component={featureFlags?.CHAT ? ChatsPageConnected : NoFeatureComp} />} />
                <Route path={PagesRoutes.Containers} element={<AuthRoute component={featureFlags?.CONTAINERS ? ContainersPageConnected : NoFeatureComp} />} />

                <Route path={`${PagesRoutes.UsersMgmt}/:userId`} element={<AuthRoute component={EditUserPageConnected} />} />
                <Route path={PagesRoutes.UsersMgmt} element={<AuthRoute component={UsersMgmtPageConnected} />} />

                <Route path={`${PagesRoutes.CompaniesMgmt}/:companyId`} element={<AuthRoute component={SingleCompanyPageConnected} />} />
                <Route path={PagesRoutes.CompaniesMgmt} element={<AuthRoute component={CompaniesMgmtPageConnected} />} />

                <Route path={PagesRoutes.CompaniesRelations} element={<AuthRoute component={CompaniesRelationsPageConnected} />} />

                <Route path={PagesRoutes.DeletedRecords} element={<AuthRoute component={DeletedRecordsPageConnected} />} />

                <Route 
                    path={PagesRoutes.Products} 
                    element={<AuthRoute component={featureFlags?.CATALOG ? ProductsPageConnected : NoFeatureComp} />} 
                />
                <Route 
                    path={`${PagesRoutes.Products}/:productId`} 
                    element={<AuthRoute component={featureFlags?.CATALOG ? ProductsPageConnected : NoFeatureComp} />} 
                />
                <Route path={PagesRoutes.Inventory} element={<AuthRoute component={featureFlags?.INVENTORY ? InventoryLogsPageConnected : NoFeatureComp} />} />
                <Route 
                    path={PagesRoutes.InternalFlowInventoryLogs} 
                    element={<AuthRoute component={featureFlags?.INTERNAL_FLOW ? InternalFlowInventoryLogsPageConnected : NoFeatureComp} />} 
                />

                <Route path={PagesRoutes.Quotation} element={<AuthRoute component={QuotationReplyPageConnected} />} />

                <Route path={`${PagesRoutes.Orders}/:orderId`} element={<AuthRoute component={SingleOrderPageConnected} />} />
                <Route path={PagesRoutes.Orders} element={<AuthRoute component={featureFlags?.ORDERS ? OrdersPageConnected : NoFeatureComp} />} />
                <Route path={PagesRoutes.OrdersBoard} element={<AuthRoute component={featureFlags?.ORDERS ? OrdersBoardPageConnected : NoFeatureComp} />} />
                <Route path={PagesRoutes.NewOrder} element={<AuthRoute component={featureFlags?.ORDERS ? OrderFormConnected : NoFeatureComp} />} />
                <Route path={`${PagesRoutes.EditOrder}/:orderId`} element={<AuthRoute component={featureFlags?.ORDERS ? OrderFormConnected : NoFeatureComp} />} />

                <Route 
                    path={`${PagesRoutes.Tariffs}/:tariffId`} 
                    element={<AuthRoute component={featureFlags?.TARIFF ? SingleTatiffPageConnected : NoFeatureComp} />} 
                />
                <Route path={PagesRoutes.Tariffs} element={<AuthRoute component={featureFlags?.TARIFF ? TarrifsPageConnected : NoFeatureComp} />} />
                <Route path={PagesRoutes.NewTariff} element={<AuthRoute component={featureFlags?.TARIFF ? TariffFormConnected : NoFeatureComp} />} />

                <Route path={`${PagesRoutes.GetStarted}/*`} element={<GetStartedPageConnected />} />
                <Route path={`${PagesRoutes.Login}/*`} element={<LoginPageConnected />} />

                <Route path={`${PagesRoutes.QuotationReply}/:bidToken`} element={<PublicRoute component={QuotationReplyPageConnected} />} />
                <Route path={`${PagesRoutes.OrderConfirmation}/:token`} element={<PublicRoute component={OrderConfirmationPageConnected} />} />
                <Route path={`${PagesRoutes.PoSupplierUpdates}/:poSupplierUpdatesToken`} element={<PublicRoute component={PoSupplierUpdatesConnected} />} />
                {/* Shipping Estimates hidden (decommission phase 1) — gated behind CARRIER_WEIGHT_PRICING flag. */}
                <Route path={PagesRoutes.ShippingEstimates} element={<PublicRoute component={featureFlags?.CARRIER_WEIGHT_PRICING ? ShippingEstimatesPageConnected : NoFeatureComp} />} />

                <Route path={PagesRoutes.Error} element={<AuthRoute component={() => <ExceptionPage status={404} title="Not found" />} />} />
                {/* Carrier Weight Pricing hidden (decommission phase 1) — gated behind CARRIER_WEIGHT_PRICING flag. */}
                <Route path={PagesRoutes.CarrierWeightPricing} element={<AuthRoute component={featureFlags?.CARRIER_WEIGHT_PRICING ? CarrierWeightPricing : NoFeatureComp} />} />
                <Route path={PagesRoutes.Followup} element={<AuthRoute component={FollowUpConnected} />} />
                <Route
                    path={PagesRoutes.AccountingOversight}
                    element={<AuthRoute component={!featureFlags?.UNDER_FORWARDER ? AccountingOversightPageConnected : NoFeatureComp} />}
                />
                
                {/* Audit Trail Routes */}
                <Route path={PagesRoutes.AuditTrail} element={<AuthRoute component={AuditDashboardPageConnected} />} />

                {/* Platform super admin */}
                <Route path={PagesRoutes.PlatformHub} element={<AuthRoute component={PlatformLayout} />}>
                    <Route index element={<PlatformHubPageConnected />} />
                    <Route path="companies" element={<PlatformCompaniesPageConnected />} />
                    <Route path="users" element={<PlatformUsersPageConnected />} />
                    <Route path="audit" element={<PlatformAuditPageConnected />} />
                    <Route path="admins" element={<PlatformSuperAdminsPageConnected />} />
                </Route>
                
                <Route path="*" element={<Navigate to={PagesRoutes.Error} />} />
            </RouterRoutes>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    localization: localizationSelectors.routes(state),
    featureFlags: userSelectors.featureFlags(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    setCurrentPageTitle: (title: string | null) => dispatch.header.setCurrentPageTitle(title),
    setHasGoBackBtn: (visible: boolean) => dispatch.header.setHasGoBackBtn(visible),
    addPath: (path: string) => dispatch.pagesHistory.addPath(path)
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);